export default __webpack_public_path__ + "static/media/help-circle.157bf91d.svg";